import React from "react";
import styles from '../styles/educationloan.module.scss';
import WebinarEvents from "./WebinarEvents";
import Container from 'react-bootstrap/Container';
import Ratio from "react-bootstrap/Ratio";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import CustomImage from "./CustomImage";
import FeaturedBlogs from "./FeaturedBlogs";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import NeedGuidance from "./NeedGuidance";
import Testimonial from "./Testimonial";
import KcNewLatestUpdates from "./kcNewlatestupdates";
import FaqComponent from "./PST/FrequentlyAskedQuestions";
import VideoTestimonials from "./PST/VideoTestimonials";
import router from "next/router";
import { isFrappeOrJotFormClass } from "../utils/helpers";
import LazyMedia from "./LazyMedia";

const EducationLoan: React.FC = (props: any) => {

  return (
    <>
      <div id="education-loan" className={styles.dynamicBg}>
        <Container>
          <div className={styles.mainSectionBg}>
            <div className={styles.contentDiv}>
              <Row>
                <Col lg={6} md={6} xs={12}>
                  <div className="d-block d-sm-none">
                    <div className="d-flex justify-content-center">
                      <Breadcrumb className={styles.mobileBreadCrum}>
                        <Breadcrumb.Item href="/" style={{ opacity: 0.5 }}>
                          Home
                        </Breadcrumb.Item>
                        <Breadcrumb.Item href="" >
                          Education loans 
                        </Breadcrumb.Item>
                      </Breadcrumb>
                    </div>
                    <CustomImage src={props.pageData?.mainImageUrl} alt={props.pageData?.mainImageAltTag} width={540} height={400} />
                  </div>
                  <div className={styles.servContent}>
                    <Breadcrumb className="d-none d-sm-block">
                      <Breadcrumb.Item href="/" style={{ opacity: 0.5 }}>
                        Home
                      </Breadcrumb.Item>
                      <Breadcrumb.Item href="" >
                          Education loans 
                      </Breadcrumb.Item>
                    </Breadcrumb>
                    <h1>{props.pageData?.title}</h1>
                    <p>{props.pageData?.description}</p>
                    <Button variant="primary" size="lg" className={`${isFrappeOrJotFormClass(props.pageData?.meta?.jotforms[0]?.jotformid)}`} onClick={()=>{
                      !props?.pageData?.meta?.jotforms[0]?.jotformid && router.push(props?.pageData?.externalLink)
                     }}>
                      { props?.pageData?.bannerBtn?.label|| 'Enquiry Now'}
                    </Button>
                  </div>
                </Col>
                <Col lg={6} md={6} xs={12}>
                  <div className="d-none d-sm-block text-center">
                    <CustomImage src={props.pageData?.mainImageUrl} alt={props.pageData?.mainImageAltTag} width={600} height={507} />
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Container>
      </div>

      {/* loan Division */}
      <div id="loan-processtop" className={styles.loanProcesstop}>
        <Container>
          <Row className="text-center">
            <div >
              <h2 className={styles['loan-div-heading']}>{props.pageData?.loanDivision?.sectionTitle}</h2>
            </div>
          </Row>
          <Row>
            <Col xs={12} sm={6} lg={6}>
              {/* mobile img */}
              <div className="d-block d-sm-none mb-5">
                   <CustomImage src={props.pageData?.loanDivision?.sectionImageUrl || '/'} alt={props.pageData?.loanDivision?.sectionImageAltTag} width={490} height={440} />
              </div>
              <div className={styles.multi_country_content}>
                <p> {props.pageData?.loanDivision?.sectionDescription} </p>
              </div>
            </Col>
            {/* desktop img */}
            <Col xs={12} sm={6} lg={6} className="d-none d-sm-block">
              <div className="mb-5">
                <CustomImage src={props.pageData?.loanDivision?.sectionImageUrl || '/'} alt={props.pageData?.loanDivision?.sectionImageAltTag} width={490} height={440} />
              </div>
            </Col>
          </Row>

          <Row>
            <Col xs={12} sm={6} lg={6}>
               {/* mobile heading */}
              <div className="d-block d-sm-none">
                 <h2 className={styles.titlebom2}>{props.pageData?.studyDreams?.sectionTitle}</h2>
              </div>
              <div className="mb-5">
                 <CustomImage src={props.pageData?.studyDreams?.sectionImageUrl} alt={props.pageData?.studyDreams?.sectionImageAltTag} width={490} height={440} />
              </div>
            </Col>
            <Col xs={12} sm={6} lg={6}>
              <div className={styles.multi_country_content}>
                {/* desktop heading */}
                <div className="d-none d-sm-block">
                   <h2 className={styles.titlebom2}>{props.pageData?.studyDreams?.sectionTitle}</h2>
                </div>
                <p>
                  {props.pageData?.studyDreams?.sectionDescription}
                </p>
                <ul>
                  {props.pageData?.studyDreams?.sectionPoints.length > 0 &&
                    props.pageData.studyDreams.sectionPoints.map((point: string, index: number) => <li key={index}>{point}</li>)
                  }
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      {/* Loan Process */}
      <div id="loan-process" className={styles.loanProcess}>
        <Container>
          <h2>
            <span>{props.pageData?.loanProcess?.sectionTitle}</span>
          </h2>
          <h3>{props.pageData?.loanProcess?.sectionDescription}</h3>
          <Row>
            <Col xs={12} lg={6} className={styles.centered}>
              <ol>
                {
                  props.pageData?.loanProcess?.loanProcessPoints?.length > 0 &&
                  props.pageData.loanProcess.loanProcessPoints.map((points: any, index: number) =>
                    <li key={index}>
                      <div className={styles.decimals}>{index + 1}</div>
                      <span>
                        <CustomImage src={points.pointImageUrl} alt={points.pointImageAltTag} width={70} height={70} />
                      </span>
                      <div>{points.point}</div>
                    </li>
                  )
                }
              </ol>
            </Col>
          </Row>

        </Container>
      </div>

      <div id="searvice-loan" className={styles.searviceLoan}>
        <Container>
          <Row>
            <Col xs={12} lg={6}>
              <div id="platform-content" className={styles.PlatformContent}>
                {/* mobile img */}
                <div className="d-block d-sm-none">
                  <h3 className={styles.mobileh3}>{props.pageData?.ancillaryServices?.sectionTitle}</h3>
                  <div className={styles.platformDivImg}>
                    <CustomImage src={props.pageData?.ancillaryServices?.sectionImageUrl} alt={props.pageData?.ancillaryServices?.sectionImageAltTag} width={333.98} height={279.13} />
                  </div>
                </div>
                <div className="d-none d-sm-block">
                   <h3 className={styles.ancillaryServicesTitle}>{props.pageData?.ancillaryServices?.sectionTitle}</h3>
                </div>
                <p>{props.pageData?.ancillaryServices?.sectionDescription}</p>
                <ul className="pl-0">
                  {
                    props.pageData?.ancillaryServices?.sectionPoints?.length > 0 &&
                    props.pageData?.ancillaryServices?.sectionPoints.map((point: string, index: number) =>
                      <li key={index}>{point}</li>
                    )
                  }
                </ul>
              </div>
            </Col>
            <Col xs={12} lg={6}>
              {/* desktop img */}
              <div className=" d-none d-sm-block">
                <div id="platform-images" className={styles.platformDivImg}>
                  <CustomImage src={props.pageData?.ancillaryServices?.sectionImageUrl} alt={props.pageData?.ancillaryServices?.sectionImageAltTag} width={490} height={440} />
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col className="text-center">
              <div id="regional-manvedio" className={styles.regionalManVedio}>
                <Container>
                  <Row className="text-center">
                    <div className={styles.videoTitle}>
                      <h3>ÉLAN Education Loan : Video</h3>
                    </div>
                  </Row>
                  <Row>
                    <Col className="d-flex justify-content-center">
                      <div className={styles.videoContainer} >
                        <Ratio aspectRatio="16x9">
                          <LazyMedia embedClassName={styles.mangerVideo} tag='embed' type='image/svg+xml' src={props.pageData?.loanEmbedUrl} />
                        </Ratio>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className={styles.webinarEventsMianSection} >
        <WebinarEvents headingLevel={2}/>
      </div>
      <Testimonial title='Our students love us' bgColor='#FFFFFF' slug={`student-testimonials?type=educationloan&_limit=15&_sort=id:DESC`} />
      <div className={styles.EduLoanLatestKcUpdates}>
        {props.pageData?.videoTestimonial &&
          <VideoTestimonials {...props.pageData.videoTestimonial} parentContainerStyles={{marginBottom: '80px'}}/>}
        <KcNewLatestUpdates {...props} />
      </div>
      <div className={styles.homePageBlogs}>
        <FeaturedBlogs />
      </div>
      {props.pageData?.faq &&
        <FaqComponent {...props.pageData.faq} />}
      <NeedGuidance classname={`${isFrappeOrJotFormClass(props.pageData?.meta?.jotforms[0]?.jotformid)}`} />

    </>

  )
}

export default EducationLoan;